// 文字列バリデーション用ユーティリティ群
// 全角・半角チェック、日付チェック、メールアドレスチェックなどを提供する。
// 現行システム（So-net OLSU）のJavaロジックをTypeScriptに移植したものも含む。

import { RegrexPattern } from './regrexPattern';

/**
 * 全角文字のみで構成されているかを判定する
 * 半角英数字・半角カナが含まれている場合はfalseを返す。
 * 現行Javaソース: nuro-olsu/src/main/java/jp/co/so_net/mv/olsu/util/StringFormatCheckUtil.java
 *
 * @param str 検査対象の文字列
 * @returns 全角文字のみの場合true
 */
// nuro-olsu/src/main/java/jp/co/so_net/mv/olsu/util/StringFormatCheckUtil.java
const isZenkakuOnly = (str: string | undefined): boolean => {
  if (!str) return false;
  const regex = /^[^ -~｡-ﾟ]+$/;
  return regex.test(str);
};
export { isZenkakuOnly };

/**
 * 全角カタカナのみで構成されているかを判定する
 * 氏名カナ入力欄などのバリデーションで使用する。
 *
 * @param str 検査対象の文字列
 * @returns 全角カタカナのみの場合true
 */
const isZenkakuKanaOnly = (str: string | undefined): boolean => {
  if (!str) return false;
  const regex = /^[ァ-ヶー\u3000]*$/;
  return regex.test(str);
};
export { isZenkakuKanaOnly };

/**
 * 有効な月（1〜12）かどうかを判定する
 * クレジットカードの有効期限など月の入力値を検証する際に使用する。
 *
 * @param str 月を表す文字列
 * @returns 1〜12の範囲内であればtrue
 */
const isValidMondh = (str: string | undefined): boolean => {
  if (!str) return false;
  const month = Number(str);
  if (month < 1 || month > 12) {
    return false;
  }
  return true;
};
export { isValidMondh };

/**
 * クレジットカードの有効期限が現在より未来かどうかを判定する
 * 現在年月と比較し、入力された有効期限が期限切れでないことを確認する。
 *
 * @param year 有効期限の年（4桁の文字列）
 * @param month 有効期限の月（1〜12の文字列）
 * @returns 有効期限が未来の場合true
 */
const isValidExpiringDate = (year: string | undefined, month: string | undefined): boolean => {
  if (!year || !month) {
    return false;
  }
  if (Number.isNaN(year) || Number.isNaN(year)) {
    return false;
  }

  const nowDate = new Date(new Date().getFullYear(), new Date().getMonth());
  const checkDate = new Date(Number(year), Number(month) - 1);

  if (nowDate <= checkDate) {
    return true;
  }
  return false;
};

export { isValidExpiringDate };

/**
 * Eメールアドレスのフォーマットチェック
 * @param str チェック対象の文字列
 * @returns 有効な文字列の場合trueを返す
 */
export const isValidEmail = (str: string | undefined) => {
  if (!str) return false;
  const regex =
    /^[a-zA-Z0-9!#$%&'*+\\\-/=?^_`{}~\\|\\.]?[a-zA-Z0-9!#$%&'*+\\\-/=?^_`{}~\\|]+(.[a-zA-Z0-9!#$%&'*+\\\-/=?^_`{}~\\|]+)*@([a-zA-Z0-9][a-zA-Z0-9-]*\.)+[a-zA-Z0-9][a-zA-Z0-9-]*$/;
  return regex.test(str);
};

/**
 * 携帯電話番号のフォーマットチェック
 * 080/090/070/060で始まる11桁の番号であることを検証する。
 *
 * @param str チェック対象の電話番号文字列
 * @returns 有効な携帯電話番号フォーマットの場合true
 */
export const isMobilePhone = (str: string): boolean => {
  if (!str) return false;
  if (str.length !== 11) return false;
  return new RegExp(RegrexPattern.mobilePhone).test(str);
};
